import type { AnswerChild, Feedback, FeedbackChildType, QuestionParent } from '../../types/feedbacks';

type AllFeedbacks = Feedback | FeedbackChildType;
type ChildrenableFeedback = Exclude<AllFeedbacks, QuestionParent | AnswerChild>;

export const findFeedback = <T extends AllFeedbacks>(feedbacks: T[], targetId: string): T | undefined => {
  for (let i = 0; i < feedbacks.length; i++) {
    if (feedbacks[i].id === targetId) {
      return feedbacks[i];
    }

    if ('commentChildren' in feedbacks[i]) {
      const foundFeedback = findFeedback((feedbacks[i] as ChildrenableFeedback).commentChildren, targetId);
      if (foundFeedback) {
        return foundFeedback as any;
      }
    }
  }
  return undefined;
};
